module.exports = __webpack_public_path__ + "img/shopware.283fe650.svg";